import { BrowserRouter as Router, useLocation } from "react-router-dom";
import { useEffect } from "react";
import "./App.css";
import RoutesConfig from "./routes";
import V2Banner from "shared/components/V2Banner";

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on location change
  }, [location.pathname]);

  return null;
};

const App = () => {
  return (
    <div className="app-container">
      <div className="background" />
      <Router>
        <ScrollToTop />
        <RoutesConfig />
        <V2Banner />
      </Router>
    </div>
  );
};

export default App;
